import { render } from "./ScreenQuestionButtonsBP.vue?vue&type=template&id=675ed1f4&scoped=true&ts=true"
import script from "./ScreenQuestionButtonsBP.vue?vue&type=script&lang=ts"
export * from "./ScreenQuestionButtonsBP.vue?vue&type=script&lang=ts"

import "./ScreenQuestionButtonsBP.vue?vue&type=style&index=0&id=675ed1f4&scoped=true&lang=scss"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675ed1f4"]])

export default __exports__